module.exports = __webpack_public_path__ + "static/media/code.8687ae55.svg";